module.exports = __webpack_public_path__ + "media/store/images/graficoExemplo-1c8577f0f35cd90795b5504af8dbde48.png";